var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagentaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 248,
    viewBox: "0 0 423 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.95752,
    width: 423,
    height: 246.958,
    rx: 10,
    fill: "#594AD7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2680_113797",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 423,
    height: 248
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.95752,
    width: 423,
    height: 246.828,
    rx: 10,
    fill: "#F22B5D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2680_113797)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.7917,
    cy: 257.743,
    r: 59.8229,
    fill: "#4938DE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5177,
    cy: -47.4956,
    r: 152.148,
    fill: "#4938DE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.534,
    cy: 236.095,
    r: 115.869,
    stroke: "#4938DE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.534,
    cy: 236.095,
    r: 87.536,
    stroke: "#4938DE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.534,
    cy: 236.095,
    r: 59.2026,
    stroke: "#4938DE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagentaCard);
export default __webpack_public_path__ + "static/media/magentaCard.d3e7c270c8dd4297c10d490dc44f923a.svg";
export { ForwardRef as ReactComponent };